import React from 'react';
import { CareersViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: CareersViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
